import {clearFeedbacksByName, fillInputsByName, getInputsByName} from "../../helpers/forms";
import {initTomSelectInput} from "../../helpers/inputs/tom-select/tom-select";
import {syncInputValue} from "../../helpers/inputs/syncInputs/syncInputValue";
import {randomUniqueId} from "../../helpers/inputs/random/strings";
import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";

function initPersonForm(formElement) {
	// Init form

	/** @var {Array} */
	let roles = JSON.parse(formElement.querySelector('input[name="existing_roles"]').value)
	let dates = JSON.parse(formElement.querySelector('input[name="existing_dates"]').value)

	// Assign client id to existing elements
	roles.forEach(role => role.clientId = randomUniqueId());
	dates.forEach(date => date.clientId = randomUniqueId());

	const stateInput = formElement.querySelector('select[name="state"]');
	initTomSelectInput(stateInput);

	/** @var {HTMLElement} */
	const rolesContainer = formElement.querySelector('.roles-container');
	/** @var {HTMLElement} */
	const roleContainerTemplate = formElement.querySelector('.templates .role-container');

	/** @var {HTMLElement} */
	const datesContainer = formElement.querySelector('.dates-container');
	/** @var {HTMLElement} */
	const dateContainerTemplate = formElement.querySelector('.templates .date-container');

	// Init add role button
	const addRoleButton = formElement.querySelector('.add-role-button');
	if (addRoleButton) {
		addRoleButton.addEventListener('click', () => {
			roles.push({
				role: '',
				clientId: randomUniqueId(),
			});

			renderForm();
		});
	}

	// Init add date button
	const addDateButton = formElement.querySelector('.add-date-button');
	if (addDateButton) {
		addDateButton.addEventListener('click', () => {
			dates.push({
				date: '',
				clientId: randomUniqueId(),
			});

			renderForm();
		});
	}

	// Initial Render
	renderForm()

	// Form methods
	return {
		formElement,
		formFields: [
			'first_name',
			'last_name',
			'address',
			'city',
			'state',
			'zip',
			'email',
			'phone',
		],
		inputs() {
			const data = getInputsByName(formElement, this.formFields);

			// Remove empty roles
			data.roles = roles.filter(role => {
				return role.role;
			});
			data.dates = dates;

			return data
		},
		clearFeedbacks() {
			return clearFeedbacksByName(formElement);
		},
		postUrl() {
			return formElement.dataset.url;
		}
	};

	function renderRoleContainer(roleData) {
		/** @var {HTMLElement} */
		const roleContainer = roleContainerTemplate.cloneNode(true);

		fillInputsByName(roleContainer, roleData)

		// Init delete button
		roleContainer.querySelector('.remove-role-button').addEventListener('click', () => {
			// Update roles array
			roles = roles.filter(role => role.clientId !== roleData.clientId);
			renderForm();
		});

		// Sync inputs with in memory object
		syncInputValue(roleData, roleContainer.querySelector('input'), 'role');

		rolesContainer.appendChild(roleContainer);
	}

	function renderDateContainer(dateData) {
		/** @var {HTMLElement} */
		const dateContainer = dateContainerTemplate.cloneNode(true);

		fillInputsByName(dateContainer, dateData)

		// Init flatpicker instance
		const dateInput = dateContainer.querySelector('input');
		initFlatPickerInput(dateInput, {
			enableTime: true,
		});

		// Init delete button
		dateContainer.querySelector('.remove-date-button').addEventListener('click', () => {
			// Update dates array
			dates = dates.filter(date => date.clientId !== dateData.clientId);
			renderForm();
		});

		// Manually load in memory default value from  flatpicker
		dateData.date = dateInput.value;
		// Sync inputs with in memory object
		syncInputValue(dateData, dateInput, 'date');

		datesContainer.appendChild(dateContainer);
	}

	function renderForm() {
		// Render roles
		rolesContainer.innerHTML = '';
		roles.forEach(renderRoleContainer);

		// Render dates
		datesContainer.innerHTML = '';
		dates.forEach(renderDateContainer);
	}
}

export {initPersonForm}
